import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  Grid,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  DialogContentText,
  Autocomplete,
  useTheme,
  useMediaQuery
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HiOutlineIdentification } from 'react-icons/hi';
import { TiUserOutline } from 'react-icons/ti';
import { RiGalleryUploadLine } from 'react-icons/ri';
import { BsShieldFillCheck, BsPatchCheck } from 'react-icons/bs';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDispatch } from 'react-redux';
import inputValidation from '../utils/globalValidation';
import AgreementText from './AgreementText';
import partnerService from './services/partnerService';
import Loader from './Loader';
import ErrorDialogBox from './ErrorDialogBox';
import cancelChequeDummy from './Journey/dummy/cancelChequeDummy.png';
import photoDummy from './Journey/dummy/photoDummy.jpg';
import panCardDummy from './Journey/dummy/panCardDummy.jpg';
import aadharFrontDummy from './Journey/dummy/aadharFrontDummy.jpg';
import {
  checkDataApi,
  getCityData,
  getSignUpCreatePartnerData,
  getSignUpDocumentTypeData,
  getStateData,
  saveApiData,
  savefileApiData
} from '../store/Slice/Global/GlobalSlice';
import { loginApi, OnboardingApi } from '../utils/Apis';
import { setApiError } from '../store/Slice/Error/ErrorSlice';
import { VerifyFileData } from '../store/Slice/Onboarding/OnboardingSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const {
  StateList,
  CityList,
  DocumentUpload,
  DocumentTypes,
  CreatePartner,
  RequestOtp,
  VerifyOtp,
  OnBoardReview
} = partnerService;
// /video-react/dist/video-react.css
function SignUpIndividual() {
  const { search } = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'), { noSsr: true });
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });

  const rawUserId = new URLSearchParams(search).get('userId');
  const userId = rawUserId?.replace(/^"|"$/g, '');

  const [signUpAuthToken, setSignUpAuthToken] = useState('');
  const navigate = useNavigate();
  const [secondary, setSecondary] = useState(false);
  const [signupSteps, setSignupSteps] = useState('verifyIdentity');
  const [verifySteps, setVerifySteps] = useState('verifyStepOne');
  const [requestOtpData, setReuestOtp] = useState('verifyStepOne');
  const [resendDisable, setResendDisable] = useState(true);
  const [error, setError] = useState(false);
  const [chequePreview, setChequePreview] = useState(cancelChequeDummy);

  const [helperText, setHelperText] = useState('');
  const [mobileHelper, setMobileHelper] = useState('');
  const [mobileError, setMobileError] = useState(false);

  const [counter, setCounter] = useState(1);
  const [photoPreview, setPhotoPreview] = useState(photoDummy);
  const [panPreview, setPanPreview] = useState(panCardDummy);
  const [aadharFrontPreview, setAadharFrontPreview] = useState(aadharFrontDummy);
  const [aadharBackPreview, setAadharBackPreview] = useState(); // aadhaar card backside
  const [cancelChequePreview, setCancelChequePreview] = useState(); // cancel cheque

  const [photoPreviewtype1, setPhotoPreviewtype1] = useState(''); // photo local
  const [panPreviewtype1, setPanPreviewtype1] = useState(''); // pan card local
  const [aadharFrontPreviewtype1, setAadharFrontPreviewtype1] = useState(''); // aadhaar card frontside local
  const [aadharBackPreviewtype1, setAadharBackPreviewtype1] = useState(''); // aadhaar card backside local
  const [cancelChequePreviewtype1, setCancelChequePreviewtype1] = useState(''); // cancel cheque local
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1); // setting 1 to show fisrt page

  const [uploadImageFile, setUploadImageFile] = useState(''); // uploaded image file
  const [uploadImageFileFront, setUploadImageFileFront] = useState(); // uploaded image file frontside
  const [uploadImageFileBack, setUploadImageFileBack] = useState(); // uploaded image file backside
  const [uploadPanImage, setUploadPanImage] = useState();
  const [uploadChequeImage, setUploadChequeImage] = useState();
  const [selectState, setSelectState] = useState(' ');
  const [selectCity, setSelectCity] = useState(' ');
  const [isActive, setActive] = useState(false);
  const [selectDate, setSelectDate] = useState('');
  const [openAssign, setOpenAssign] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(); // uploaded image file frontside
  const [chequePreviewtype1, setChequePreviewtype1] = useState('');
  const [panPreviewType, setPanPreviewType] = useState('');

  // api state
  const [stateListResponse, setStateListResponse] = useState([]);
  const [cityListResponse, setCityListResponse] = useState([]);
  const [stateID, setStateID] = useState('');
  const [stateValue, setStateValue] = useState('');
  const [cityID, setCityID] = useState('');
  const [cityValue, setCityValue] = useState('');

  const [aadharFrontPreviewtype1live, setAadharFrontPreviewtype1live] = useState('');
  const [aadharBackPreviewtype1live, setAadharBackPreviewtype1live] = useState('');
  const [panPreviewtype1live, setPanPreviewtype1live] = useState('');
  const [cancelChequePreviewtype1live, setCancelChequePreviewtype1live] = useState('');
  const [photoPreviewtype1live, setPhotoPreviewtype1live] = useState('');

  const [documentTypesList, setDocumentTypesList] = useState({});
  const [createPartnerData, setCreatePartnerData] = useState({});
  //
  const [stateListData, setStateListData] = useState([]);
  const [cityListData, setCityListData] = useState([]);
  const [checked, setChecked] = useState('');
  const [currentDate, setCurrentDate] = useState({});
  const [indDobYear, setIndDobYear] = useState({});
  const [aadharPreviewType, setAadharPreviewType] = useState('');
  const [aadharRefId, setAadharRefId] = useState(null);

  // Email OTP
  const [emailOtpOpen, setEmailOtpOpen] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  // Mobile OTP
  const [mobileOtpOpen, setMobileOtpOpen] = useState(false);
  const [mobileOtp, setMobileOtp] = useState('');
  const [isMobileVerified, setIsMobileVerified] = useState(false);

  // AADHAR VERIFICATION STATES
  const [aadharModalOpen, setAadharModalOpen] = useState(false);
  const [aadharNumber, setAadharNumber] = useState('');
  const [aadharOtpValue, setAadharOtpValue] = useState('');
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [isAadharVerified, setIsAadharVerified] = useState(false);
  const [aadharOtpLoading, setAadharOtpLoading] = useState(false);
  const [uploadAadharForVerification, setUploadAadharForVerification] = useState(null);
  const [aadharPreviewForVerification, setAadharPreviewForVerification] = useState('');

  // PAN VERIFICATION STATES
  const [panModalOpen, setPanModalOpen] = useState(false);
  const [panNumber, setPanNumber] = useState('');
  const [panName, setPanName] = useState('');
  const [panDob, setPanDob] = useState('');
  const [uploadPanForVerification, setUploadPanForVerification] = useState(null);
  const [panPreviewForVerification, setPanPreviewForVerification] = useState('');
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [panVerificationLoading, setPanVerificationLoading] = useState(false);

  const [otpLoading, setOtpLoading] = useState(false);
  const [verifyMail, setVerifyMail] = useState(false);
  const [verifyMobile, setVerifyMobile] = useState(false);

  const dispatch = useDispatch();

  const handleFileUpload = (e, setPreview, setUploadImage, setLocaltype) => {
    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

    if (!file) return;

    setLocaltype(file.name.split('.').pop());
    setUploadImage(file);
    setPreview(URL.createObjectURL(file));
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const dragOver = (e) => {
    e.preventDefault();
  };
  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };
  const fileDrop = (e, setPreview, setUploadImage, setLocaltype) => {
    e.preventDefault();
    handleFileUpload(e, setPreview, setUploadImage, setLocaltype);
  };

  // Signup verify identity const by man 27 May 2022
  const handleClose = () => {
    setOpen(false);
  };
  // Valid identity
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [emailAddr, setEmailAddr] = useState();
  // Otp section
  const [otp, setOtp] = useState('');
  // Personal details
  const [fname, setFname] = useState('');
  const [address, setAddress] = useState();
  // Validation and open dialog
  const [validationMsg, setValidationMsg] = useState('');
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showErrorPopUp, setshowErrorPopUp] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  // Signup const

  const handleSignUp = async (e) => {
    const typeId = JSON.parse(localStorage.getItem('typeID'));
    const trackuserData = await JSON.parse(localStorage.getItem('trackuser'));
    setHelperText('');
    setError(false);
    const pattern = /^[6-9][0-9]{9}$/; // mobile regex pattern
    const mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // email regex pattern

    if (!name || name.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter your name');
      return;
    }
    if (!pattern.test(phone)) {
      setOpen(true);
      setValidationMsg('Please enter valid mobile number');
      return;
    }

    if (!mailformat.test(emailAddr)) {
      setOpen(true);
      setValidationMsg('Please enter your E-Mail address');
      return;
    }

    let localData = '';
    if (trackuserData != null) {
      localData = trackuserData?.isPartnerSignupContinued;
    }

    const createCredentials = {
      companyId: 36,
      typeId: typeId ? typeId?.typeId : 66, // from localStorage
      partnerStatusTypeId: 82,
      reportingManagerId: userId ? userId : null,
      partnerName: String(name),
      mobile: String(phone),
      emailAddress: String(emailAddr),
      isSignUpFlow: true,
      fathersName: String(fname),
      isNextUserAllowed: false,
      isPartnerLoginAllowed: false,
      isPartnerSignupContinued: localData !== '' && localData !== undefined ? localData : false
    };
    setLoader(true);
    const CreatePartnerApiResponse = await dispatch(
      checkDataApi(`${loginApi?.signupContactPerson}/${String(phone)}/${String(emailAddr)}`, '')
    );
    setLoader(false);
    if (CreatePartnerApiResponse.status === 'success') {
      if (CreatePartnerApiResponse.data.mobileNumberCheckMsg) {
        setMobileError(true);
        return;
      }
      localStorage.setItem('reviewobj', JSON.stringify(CreatePartnerApiResponse.data));
    }

    setSignupSteps('personalDetails');
  };

  const handleSignUpTwo = async () => {
    if (!otp || otp.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter OTP');
      return;
    }
    const verifytotp = await VerifyOtp(
      {
        mobileNumber: phone,
        otp: otp,
        emailAddress: emailAddr,
        token: requestOtpData.token,
        iat: requestOtpData.iat
      },
      signUpAuthToken
    );

    setLoader(false);
    if (verifytotp.status === 'success') {
      setSignupSteps('personalDetails');
    } else {
      setResendDisable(false);
      setError(true);
      setHelperText('Unable to verify OTP - invalid OTP! Or OTP Expired');
    }
  };

  const handleDob = (e) => {
    setSelectDate(e.target.value);
    const fullYear = new Date(e.target.value).getFullYear();
    setIndDobYear(fullYear);
  };

  // Personal Details
  const handleSignUpThree = async () => {
    const typeId = JSON.parse(localStorage.getItem('typeID'));

    if (!fname || fname.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter your father name');
      return;
    }

    const diff = currentDate - indDobYear;
    if (selectDate === '') {
      setOpen(true);
      setValidationMsg('Please enter your Date of Birth');
      return;
    } else if (diff < 18) {
      setOpen(true);
      setValidationMsg('Age should be greater then 18 years');
      return;
    }

    if (!address || address.trim() === '') {
      setOpen(true);
      setValidationMsg('Please enter your address');
      return;
    }
    if (!stateID) {
      setOpen(true);
      setValidationMsg('Please enter your city');
      return;
    }
    if (!cityID) {
      setOpen(true);
      setValidationMsg('Please enter your state');
    }
    const createCredentials = {
      companyId: 36,
      typeId: typeId ? typeId?.typeId : 66, // from localStorage
      partnerStatusTypeId: 82,
      reportingManagerId: userId ? userId : null,
      partnerName: String(name),
      fathersName: String(fname),
      dob: String(selectDate),
      mobile: String(phone),
      address: String(address),
      emailAddress: String(emailAddr),
      districtId: Number(cityID),
      provinceId: Number(stateID),
      countryId: 101,
      isSignUpFlow: true,
      // partnerId: createPartnerData?.partnerId,
      isNextUserAllowed: false,
      isPartnerLoginAllowed: false,
      isAgreementChecked: true
    };
    setLoader(true);
    // console.log('call 1');
    const CreatePartnerApiResponse = await dispatch(getSignUpCreatePartnerData(createCredentials));
    // const CreatePartnerApiResponse = await CreatePartner(createCredentials, signUpAuthToken);
    setLoader(false);

    if (CreatePartnerApiResponse?.data?.status === 'success') {
      // isPartnerAlreadyExist
      setCreatePartnerData(CreatePartnerApiResponse.data);
      localStorage.setItem('reviewobj', JSON.stringify(CreatePartnerApiResponse.data));
      setSignupSteps('uploadDocuments');
      dispatch(setApiError('To create a partner, Aadhaar and PAN cards are mandatory.'));
    } else {
      const errorMsg =
        CreatePartnerApiResponse?.description ||
        CreatePartnerApiResponse?.msg ||
        'Partner creation failed';

      dispatch(setApiError(errorMsg));
    }
  };

  // document validation
  const documentValidation = (e) => {
    if (!isAadharVerified) {
      setOpen(true);
      setValidationMsg('Please upload aadhar card photo');
      return;
    }

    if (!isPanVerified) {
      setOpen(true);
      setValidationMsg('Please Upload Pan Card Photo');
      return;
    }

    fireAllDocumentApi(e);
    setSignupSteps('results');
  };

  // fire document apis
  const fireAllDocumentApi = (e) => {
    // console.log('uploadImageFileFront:', uploadImageFileFront);
    // console.log('uploadImageFileBack:', uploadImageFileBack);
    // console.log('createPartnerData rrrrr', createPartnerData);
    if (uploadPhoto) {
      (async () => {
        // user photo
        const formData = new FormData();
        formData.append('partnerId', createPartnerData.partnerId);
        formData.append('companyId', 36);
        documentTypesList.forEach((item) => {
          if (item.typeCode.toLowerCase() === 'USER IMAGE'.toLowerCase()) {
            formData.append('documentTypeId', item.typeId);
          }
        });
        formData.append('userImage', uploadPhoto);
        return fetch(DocumentUpload(), {
          method: 'POST',
          // headers: {
          //   Authorization: `Bearer ${signUpAuthToken}`
          // },
          body: formData
        }).then((response) => {
          response.json().then((data) => {
            if (data.status === 'success') {
              // upload success
            }
          });
        });
      })();
    }

    if (uploadImageFileFront || uploadImageFileBack) {
      // adhar api
      (async () => {
        // aadhar card api
        const formData = new FormData();
        formData.append('partnerId', createPartnerData.partnerId);
        formData.append('companyId', 36);

        // Find document type by flexible matching
        let aadharDocTypeId = null;
        documentTypesList.forEach((item) => {
          const typeCode = (item.typeCode || '').toUpperCase();
          const typeName = (item.typeName || '').toUpperCase();

          if (typeCode.includes('AADHAR CARD') || typeName.includes('AADHAR CARD')) {
            aadharDocTypeId = item.typeId || item.value;
          }
        });

        if (aadharDocTypeId) {
          formData.append('documentTypeId', aadharDocTypeId);
        }

        if (uploadImageFileFront) {
          formData.append('aadharFront', uploadImageFileFront);
        }
        if (uploadImageFileBack) {
          formData.append('aadharBack', uploadImageFileBack);
        }
        return fetch(DocumentUpload(), {
          method: 'POST',
          // headers: {
          //   Authorization: `Bearer ${signUpAuthToken}`
          // },
          body: formData
        }).then((response) => {
          response.json().then((data) => {
            if (data.status === 'success') {
              // upload success
            }
          });
        });
      })();
    }

    if (uploadPanImage) {
      // pan card
      (async () => {
        // pan card api
        const formData1 = new FormData();
        formData1.append('partnerId', createPartnerData?.partnerId);
        formData1.append('companyId', 36);
        documentTypesList.forEach((item) => {
          if (item.typeName === 'PAN CARD') {
            formData1.append('documentTypeId', item?.typeId);
          }
        });
        formData1.append('panCard', uploadPanImage);
        return fetch(DocumentUpload(), {
          method: 'POST',
          // headers: {
          //   Authorization: `Bearer ${signUpAuthToken}`
          // },
          body: formData1
        }).then((response) => {
          response.json().then((data) => {
            if (data?.status === 'success') {
              // upload success
            }
          });
        });
      })();
    }

    if (uploadChequeImage) {
      // cheque
      (async () => {
        // cheque api
        const formData2 = new FormData();
        formData2.append('partnerId', createPartnerData.partnerId);
        formData2.append('companyId', 36);
        documentTypesList.forEach((item) => {
          if (item.typeName === 'Cheque') {
            formData2.append('documentTypeId', item.typeId);
          }
        });
        formData2.append('cheque', uploadChequeImage);

        return fetch(DocumentUpload(), {
          method: 'POST',
          // headers: {
          //   Authorization: `Bearer ${signUpAuthToken}`
          // },
          body: formData2
        }).then((response) => {
          response.json().then(() => {});
        });
      })();
    }
  };
  // Signup verify identity const end
  useEffect(() => {
    let cancel = false;
    const SignUpToken = JSON.parse(localStorage.getItem('guestUser'));
    const SignUpAuthToken = SignUpToken?.token;
    setSignUpAuthToken(SignUpAuthToken);
    // state apis
    const credential = {
      searchLiteral: null,
      countryId: 101
    };
    const StateListApi = async () => {
      // const StateListResponse = await StateList(credential, SignUpAuthToken);
      const StateListResponse = await dispatch(getStateData(credential));
      if (StateListResponse?.action_status === 'success') {
        // if (cancel) return;
        setStateListResponse(StateListResponse?.data);
      } else {
        setStateListResponse([]);
      }
    };
    StateListApi();

    // document types api
    (async () => {
      const DocumentTypesApiResponse = await dispatch(getSignUpDocumentTypeData());
      if (DocumentTypesApiResponse?.status === 'success') {
        setDocumentTypesList(DocumentTypesApiResponse?.data?.documentTypes);
      } else {
        setDocumentTypesList({});
      }
    })();
    const today = new Date();
    setCurrentDate(today.getFullYear());

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    const getactivepage = JSON.parse(localStorage.getItem('trackuser'));
    if (getactivepage != null) {
      trackuserapi(getactivepage);
    }
    // const token = JSON.parse(localStorage.getItem('guestUser'));
    const reviewIdd = JSON.parse(localStorage.getItem('reviewobj'));
    if (reviewIdd !== null) {
      setCreatePartnerData(reviewIdd);
      getReviewbyid(reviewIdd);
    }
  }, []);

  const [reviewData, setReviewData] = useState([]);

  const getReviewbyid = async (credential, token) => {
    const reviewResponse = await OnBoardReview(credential, token);
    if (reviewResponse?.status === 'success') {
      setReviewData(reviewResponse?.data?.partnerDocuments ?? []);
    } else {
      setReviewData([]);
    }
  };

  const trackuserapi = (active) => {
    const getactivepage = JSON.parse(localStorage.getItem('trackuser'));
    if (getactivepage != null) {
      if (getactivepage.routepage === `${active.routepage}`) {
        if (getactivepage.stageone !== undefined) {
          setSignupSteps('verifyIdentity');
          if (Object.keys(getactivepage.stageone).length > 0) {
            if (getactivepage.stageone.name !== undefined) {
              setName(getactivepage.stageone.name);
            }

            if (getactivepage.stageone.phone !== undefined) {
              setPhone(getactivepage.stageone.phone);
            }

            if (getactivepage.stageone.emailAddr !== undefined) {
              setEmailAddr(getactivepage.stageone.emailAddr);
            }
          }
        }

        if (getactivepage.stagethree !== undefined) {
          setSignupSteps('personalDetails');
          if (Object.keys(getactivepage.stagethree).length > 0) {
            if (getactivepage.stagethree.fname !== undefined) {
              setFname(getactivepage.stagethree.fname);
            }
            if (getactivepage.stagethree.selectDate !== undefined) {
              setSelectDate(getactivepage.stagethree.selectDate);
            }
            if (getactivepage.stagethree.address !== undefined) {
              setAddress(getactivepage.stagethree.address);
            }
            if (getactivepage.stagethree.state !== undefined) {
              setStateValue(getactivepage.stagethree.state.stateName);
              setStateID(getactivepage.stagethree.state.stateId);
            }
            if (getactivepage.stagethree.city !== undefined) {
              setCityValue(getactivepage.stagethree.city.cityName);
              setCityID(getactivepage.stagethree.city.cityId);
            }
          }
        }

        if (getactivepage.stagefour !== undefined) {
          setSignupSteps('uploadDocuments');
          if (reviewData.length > 0) {
            reviewData.forEach((docItem) => {
              if (docItem.documentType.typeCode === 'CHEQUE') {
                setCancelChequePreviewtype1live(docItem.contentType);
                setCancelChequePreview(docItem.documentUrl);
              }

              if (docItem.documentType.typeCode === 'PAN CARD') {
                setPanPreviewtype1live(docItem.contentType);
                setPanPreview(docItem.documentUrl);
              }
              if (
                docItem.documentType.typeCode === 'AADHAR CARD' &&
                docItem.aadharFrontFace === false
              ) {
                setAadharBackPreviewtype1live(docItem.contentType);
                setAadharBackPreview(docItem.documentUrl);
              }

              if (docItem.documentType.typeCode === 'USER IMAGE') {
                setPhotoPreviewtype1live(docItem.contentType);
                setPhotoPreview(docItem.documentUrl);
              }

              if (
                docItem.documentType.typeCode === 'AADHAR CARD' &&
                docItem.aadharFrontFace === true
              ) {
                setAadharFrontPreviewtype1live(docItem.contentType);
                setAadharFrontPreview(docItem.documentUrl);
              }
            });
          }
        }

        if (getactivepage.stagefifth !== undefined) {
          setSignupSteps('results');
        }

        if (getactivepage.stagelast !== undefined) {
          setOpenAssign(true);
        }
      }
    }
  };

  const handleEmailSendOtp = async () => {
    if (!emailAddr) {
      dispatch(setApiError('Please enter email'));
      return;
    }

    const payload = { email: emailAddr };
    const res = await dispatch(saveApiData(OnboardingApi.onBoardEmailSend, payload));

    if (res?.status === 'success') {
      setEmailOtpOpen(true);
      dispatch(setApiError('OTP sent to your email'));
    }
  };

  const handleEmailVerifyOtp = async () => {
    if (!emailOtp) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      email: emailAddr,
      otp: emailOtp
    };

    const res = await dispatch(saveApiData(OnboardingApi.onBoardEmailVerify, payload));

    if (res?.status === 'success') {
      setIsEmailVerified(true);
      setEmailOtp('');
      setEmailOtpOpen(false);
      dispatch(setApiError('Email verified successfully'));
    }

    setOtpLoading(false);
  };

  const handleMobileSendOtp = async () => {
    if (!phone) {
      dispatch(setApiError('Please enter mobile number'));
      return;
    }

    const payload = { mobileNumber: phone };
    const res = await dispatch(saveApiData(OnboardingApi.onBoardMobileSend, payload));

    if (res?.success === true) {
      setMobileOtpOpen(true);
      dispatch(setApiError('OTP sent to your mobile'));
    }
  };

  const handleMobileVerifyOtp = async () => {
    if (!mobileOtp) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setOtpLoading(true);

    const payload = {
      mobileNumber: phone,
      otp: mobileOtp
    };

    const res = await dispatch(saveApiData(OnboardingApi.onBoardMobileVerify, payload));

    if (res?.success === true) {
      setIsMobileVerified(true);
      setMobileOtp('');
      setMobileOtpOpen(false);
      dispatch(setApiError('Mobile verified successfully'));
    }

    setOtpLoading(false);
  };

  async function handleAadharSend() {
    if (!aadharNumber) {
      alert('Please enter Aadhar number');
      return;
    }
    if (!uploadAadharForVerification) {
      alert('Please upload Aadhar document');
      return;
    }

    setAadharOtpLoading(true);

    try {
      const formData = new FormData();
      formData.append('aadhaar_no', aadharNumber);
      formData.append('aadhaar_doc', uploadAadharForVerification);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      // Call your API - adjust endpoint as needed
      const result = await dispatch(savefileApiData(OnboardingApi?.onBoardAadharSend, formData));

      if (result?.success === true) {
        setOtpGenerated(true);
        dispatch(setApiError('OTP sent to your registered mobile'));
      } else {
        dispatch(setApiError(result?.message || 'Failed to send OTP'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error sending OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  async function handleAadharVerifyOtp() {
    if (!aadharOtpValue) {
      dispatch(setApiError('Please enter OTP'));
      return;
    }

    setAadharOtpLoading(true);

    const payload = {
      otp: aadharOtpValue,
      ref_id: 46538513, // Get this from send OTP response
      client_id: 'pb',
      userId: 'system'
    };

    try {
      const result = await dispatch(VerifyFileData(OnboardingApi?.onBoardAadharVerify, payload));
      if (result?.success === true) {
        setIsAadharVerified(true);
        setAadharModalOpen(false);

        const previewUrl = URL.createObjectURL(uploadAadharForVerification);

        // ✅ Update CARD preview
        setAadharFrontPreview(previewUrl);
        setAadharFrontPreviewtype1(uploadAadharForVerification.name.split('.').pop());

        // ✅ CRITICAL → Set main upload state
        setUploadImageFileFront(uploadAadharForVerification);

        dispatch(setApiError('Aadhaar verified successfully'));

        resetAadharModalStates();
      } else {
        dispatch(setApiError(result?.message || 'OTP verification failed'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying OTP'));
    } finally {
      setAadharOtpLoading(false);
    }
  }

  // PAN VERIFICATION FUNCTION
  async function handlePanVerify() {
    if (!panNumber) {
      dispatch(setApiError('Please enter PAN number'));
      return;
    }
    if (!panName) {
      dispatch(setApiError('Please enter full name'));
      return;
    }
    if (!panDob) {
      dispatch(setApiError('Please enter date of birth'));
      return;
    }
    if (!uploadPanForVerification) {
      dispatch(setApiError('Please upload PAN document'));
      return;
    }

    setPanVerificationLoading(true);

    try {
      const formData = new FormData();
      formData.append('pan_no', panNumber.toUpperCase());
      formData.append('name', panName.toUpperCase());
      formData.append('dob', panDob);
      formData.append('pan_doc', uploadPanForVerification);
      formData.append('client_id', 'pb');
      formData.append('userId', 'system');

      // Call your API - adjust endpoint as needed
      const result = await dispatch(savefileApiData(OnboardingApi?.verifyPan, formData));
      // console.log('result222', result);

      if (result?.success === true) {
        setIsPanVerified(true);
        setPanModalOpen(false);

        const previewUrl = URL.createObjectURL(uploadPanForVerification);

        // ✅ Update PAN preview on main card
        setPanPreview(previewUrl);
        setPanPreviewtype1(uploadPanForVerification.name.split('.').pop());

        // ✅ MOST IMPORTANT → Save file for upload API
        setUploadPanImage(uploadPanForVerification);

        dispatch(setApiError(result?.message || 'PAN verified successfully'));

        // Reset modal states
        setPanNumber('');
        setPanName('');
        setPanDob('');
        setUploadPanForVerification(null);
        setPanPreviewForVerification('');
      } else {
        dispatch(setApiError(result?.message || 'Please enter correct details'));
      }
    } catch (err) {
      console.error(err);
      dispatch(setApiError('Error verifying PAN'));
    } finally {
      setPanVerificationLoading(false);
    }
  }

  useEffect(() => {
    if (!emailAddr) {
      setVerifyMail(false);
      return;
    }
    const result = inputValidation({ target: { value: emailAddr } }, 'EMAIL');
    setVerifyMail(result === true);
  }, [emailAddr]);

  useEffect(() => {
    if (!phone) {
      setVerifyMobile(false);
      return;
    }
    const result = inputValidation({ target: { value: phone } }, 'MOBILE');
    setVerifyMobile(result === true);
  }, [phone]);

  const resetAadharModalStates = () => {
    setAadharNumber('');
    setAadharOtpValue('');
    setOtpGenerated(false);
    setUploadAadharForVerification(null);
    setAadharPreviewForVerification('');
    setAadharPreviewType('');
    setAadharRefId(null);
  };

  return (
    <Box
      className="signUpOuter"
      sx={{
        width: '100%',
        minHeight: '100vh'
      }}
    >
      {loader && <Loader loader={loader} />}
      {showErrorPopUp && (
        <ErrorDialogBox
          showErrorPopUp={showErrorPopUp}
          errorMsg={errorMsg}
          setshowErrorPopUp={setshowErrorPopUp}
        />
      )}
      <Container disablegutters="true">
        <Box>
          <Box
            className="signUpInner"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              minHeight: '100vh',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Box
              className="signUpLeft"
              sx={{
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Box className="signUpleftInner">
                <Box>
                  <Typography variant="h6" className="signUpHeading">
                    <img
                      className="signUpLogo"
                      alt="Logo"
                      src="../../static/logos/kalolyticLogo.svg"
                    />
                  </Typography>
                  <Box className="signUpFormLeft mt-2">
                    <Box
                      className={
                        signupSteps === 'verifyIdentity'
                          ? 'signUpFormStep mb-4 active'
                          : 'signUpFormStep mb-4'
                      }
                    >
                      <Box className="signUpFormTextBox">
                        <Typography className="signUpFormText mb-1">Select User Type</Typography>
                        <Typography className="signUpFormTextSec" variant="body2">
                          Select Your User Type for next step
                        </Typography>
                      </Box>
                      <Typography className="signUpFormIconOut">
                        <HiOutlineIdentification classname="signUpFormIcon" fontSize={24} />
                      </Typography>
                    </Box>
                    <Box
                      className={
                        signupSteps === 'personalDetails'
                          ? 'signUpFormStep mb-4 active'
                          : 'signUpFormStep mb-4'
                      }
                    >
                      <Box className="signUpFormTextBox">
                        <Typography className="signUpFormText mb-1">Personal Details</Typography>
                        <Typography className="signUpFormTextSec" variant="body2">
                          Fill in Your Name, Mobile No and verify your contact number
                        </Typography>
                      </Box>
                      <Typography className="signUpFormIconOut">
                        <TiUserOutline classname="signUpFormIcon" fontSize={24} />
                      </Typography>
                    </Box>
                    <Box
                      className={
                        signupSteps === 'uploadDocuments'
                          ? 'signUpFormStep mb-4 active'
                          : 'signUpFormStep mb-4'
                      }
                    >
                      <Box className="signUpFormTextBox">
                        <Typography className="signUpFormText mb-1">Upload Documents</Typography>
                        <Typography className="signUpFormTextSec" variant="body2">
                          Upload your KYC documents
                        </Typography>
                      </Box>
                      <Typography className="signUpFormIconOut">
                        <RiGalleryUploadLine classname="signUpFormIcon" fontSize={24} />
                      </Typography>
                    </Box>
                    <Box
                      className={
                        signupSteps === 'results'
                          ? 'signUpFormStep mb-4 active'
                          : 'signUpFormStep mb-4'
                      }
                    >
                      <Box className="signUpFormTextBox">
                        <Typography className="signUpFormText mb-1">Business Agreement</Typography>
                        <Typography className="signUpFormTextSec" variant="body2">
                          Agree to the terms &#38; conditions of the business agreement and submit
                          for activation of your id
                        </Typography>
                      </Box>
                      <Typography className="signUpFormIconOut">
                        <BsShieldFillCheck classname="signUpFormIcon" fontSize={24} />
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Mobile header: logo + horizontal step icons — visible xs/sm only */}
            <Box
              sx={{
                display: { xs: 'flex', md: 'none' },
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: '#0d4689',
                pt: 3,
                pb: 0,
                px: 2,
                width: '100%'
              }}
            >
              {/* Company logo */}
              <Box sx={{ mb: 3 }}>
                <img
                  src="../../static/logos/kalolyticLogo.svg"
                  alt="Logo"
                  style={{ height: '48px', width: 'auto' }}
                />
              </Box>

              {/* Horizontal step row */}
              <Box
                className="mobileStepIndicator"
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  width: '100%',
                  overflowX: 'auto',
                  gap: 0,
                  pb: 0
                }}
              >
                {[
                  {
                    step: 'verifyIdentity',
                    label: 'Identity',
                    icon: <HiOutlineIdentification size={22} />
                  },
                  { step: 'personalDetails', label: 'Personal', icon: <TiUserOutline size={22} /> },
                  {
                    step: 'uploadDocuments',
                    label: 'Documents',
                    icon: <RiGalleryUploadLine size={22} />
                  },
                  { step: 'results', label: 'Agreement', icon: <BsShieldFillCheck size={22} /> }
                ].map(({ step, label, icon }, idx, arr) => {
                  const isActive = signupSteps === step;
                  return (
                    <Box
                      key={step}
                      sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                        minWidth: 60
                      }}
                    >
                      {/* Connector line (left side) */}
                      {idx > 0 && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 18,
                            left: 0,
                            width: '50%',
                            height: '2px',
                            backgroundColor: isActive ? '#4fbbc8' : 'rgba(255,255,255,0.25)'
                          }}
                        />
                      )}
                      {/* Connector line (right side) */}
                      {idx < arr.length - 1 && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 18,
                            right: 0,
                            width: '50%',
                            height: '2px',
                            backgroundColor:
                              signupSteps === arr[idx + 1].step
                                ? '#4fbbc8'
                                : 'rgba(255,255,255,0.25)'
                          }}
                        />
                      )}

                      {/* Icon circle */}
                      <Box
                        sx={{
                          width: 38,
                          height: 38,
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: isActive ? '#4fbbc8' : 'rgba(255,255,255,0.15)',
                          color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
                          border: isActive
                            ? '2px solid #4fbbc8'
                            : '2px solid rgba(255,255,255,0.2)',
                          mb: 0.75,
                          zIndex: 1,
                          transition: 'all 0.3s'
                        }}
                      >
                        {icon}
                      </Box>

                      {/* Step label */}
                      <Typography
                        sx={{
                          fontSize: '0.65rem',
                          fontWeight: isActive ? 700 : 400,
                          color: isActive ? '#fff' : 'rgba(255,255,255,0.55)',
                          textAlign: 'center',
                          lineHeight: 1.2,
                          whiteSpace: 'nowrap',
                          pb: 1.5
                        }}
                      >
                        {label}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
            </Box>

            <Box className="signUpRight" sx={{ flex: 1 }}>
              <Box className="signUpRightInner">
                <Box className="signUpFormRight">
                  {signupSteps === 'verifyIdentity' ? (
                    <>
                      {' '}
                      {verifySteps === 'verifyStepOne' ? (
                        ({
                          /* First Step Start Here */
                        },
                        (
                          <Grid container alignItems="center" spacing={3}>
                            <Grid item xs={12} sm={9}>
                              <Typography variant="h6" className="mb-1">
                                Verify Identity
                              </Typography>
                              <Typography variant="body2" className="mb-3">
                                (Please fill in your contact details to start the Process)
                              </Typography>
                              <FormControl fullWidth display="flex">
                                <Box className="mb-3">
                                  <Typography variant="h6" className="formLabel">
                                    Full Name
                                  </Typography>
                                  <TextField
                                    value={name}
                                    onChange={(e) => {
                                      setName(e.target.value);
                                      let getactivepage = '';
                                      getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                      if (getactivepage != null) {
                                        if (getactivepage.routepage === 'signup-form/Individual') {
                                          getactivepage.stageone = {};
                                          getactivepage.stageone.name = e.target.value;
                                          localStorage.setItem(
                                            'trackuser',
                                            JSON.stringify(getactivepage)
                                          );
                                        }
                                      }
                                    }}
                                    type="text"
                                    variant="outlined"
                                    inputProps={{
                                      className: 'textInput'
                                    }}
                                    placeholder="Type Your Name"
                                    fullWidth
                                  />
                                </Box>
                                <Box className="mb-3">
                                  <Typography variant="h6" className="formLabel">
                                    Mobile Number
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: 'grid',
                                      gridTemplateColumns: '1fr 90px',
                                      gap: 1
                                    }}
                                  >
                                    <TextField
                                      value={phone}
                                      onChange={(e) => setPhone(e.target.value)}
                                      disabled={isMobileVerified}
                                      fullWidth
                                      placeholder="Type Mobile Number"
                                      size="small"
                                    />

                                    <Button
                                      variant="contained"
                                      disabled={isMobileVerified}
                                      sx={{
                                        backgroundColor: isMobileVerified
                                          ? '#2e7d32!important'
                                          : verifyMobile
                                          ? '#0d4689!important'
                                          : '#95989bcc',
                                        color: '#fff!important',
                                        '&:hover': {
                                          backgroundColor: isMobileVerified
                                            ? '#1b5e20'
                                            : '#95989bcc'
                                        }
                                      }}
                                      onClick={handleMobileSendOtp}
                                    >
                                      {isMobileVerified ? 'Verified' : 'Verify'}
                                    </Button>
                                  </Box>
                                </Box>

                                <Box className="mb-3">
                                  <Typography variant="h6" className="formLabel">
                                    Email
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: 'grid',
                                      gridTemplateColumns: '1fr 90px',
                                      gap: 1
                                    }}
                                  >
                                    <TextField
                                      value={emailAddr}
                                      onChange={(e) => setEmailAddr(e.target.value)}
                                      disabled={isEmailVerified}
                                      fullWidth
                                      placeholder="Type Email"
                                      size="small"
                                    />

                                    <Button
                                      variant="contained"
                                      disabled={isEmailVerified}
                                      sx={{
                                        backgroundColor: isEmailVerified
                                          ? '#2e7d32!important'
                                          : verifyMail
                                          ? '#0d4689!important'
                                          : '#95989bcc',
                                        color: '#fff!important',
                                        '&:hover': {
                                          backgroundColor: isEmailVerified ? '#1b5e20' : '#95989bcc'
                                        }
                                      }}
                                      onClick={handleEmailSendOtp}
                                    >
                                      {isEmailVerified ? 'Verified' : 'Verify'}
                                    </Button>
                                  </Box>
                                </Box>

                                <Button
                                  className="mainBtn"
                                  disabled={!isMobileVerified || !isEmailVerified}
                                  onClick={(e) => {
                                    handleSignUp(e);
                                    let getactivepage = '';
                                    getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                    if (getactivepage != null) {
                                      if (getactivepage.routepage === 'signup-form/Individual') {
                                        getactivepage.stagethree = {};
                                        localStorage.setItem(
                                          'trackuser',
                                          JSON.stringify(getactivepage)
                                        );
                                      }
                                    }
                                  }}
                                >
                                  Next
                                </Button>
                              </FormControl>
                            </Grid>
                          </Grid>
                        ))
                      ) : verifySteps === 'verifyStepTwo' ? (
                        <Grid container alignItems="center">
                          <Grid item xs={12} sm={6}>
                            <Typography variant="h6" className="mb-1">
                              Verify Identity
                            </Typography>
                            <Typography variant="body2" className="mb-3">
                              (We have send a One Time Password to your Mobile. Please fill in your
                              Mobile OTP to proceed further.)
                            </Typography>
                            <Box className="mb-3">
                              <Typography variant="h6" className="formLabel">
                                Mobile OTP
                              </Typography>
                              <TextField
                                value={otp}
                                error={error}
                                helperText={helperText}
                                onChange={(e) => setOtp(e.target.value)}
                                type="number"
                                variant="outlined"
                                inputProps={{
                                  className: 'textInput'
                                }}
                                placeholder="Type Mobile OTP"
                                fullWidth
                              />
                            </Box>
                            <Button
                              className="mainBtn"
                              // onClick={(e) => setSignupSteps('personalDetails')
                              onClick={(e) => {
                                handleSignUpTwo(e);
                              }}
                            >
                              Next
                            </Button>
                            <Button
                              disabled={resendDisable}
                              className="mainBtn"
                              sx={{ marginLeft: '15px' }}
                              // onClick={(e) => setSignupSteps('personalDetails')
                              onClick={(e) => {
                                if (counter < 3) {
                                  setCounter(counter + 1);
                                  const requestotpApi = async () => {
                                    const requestotp = await RequestOtp(
                                      {
                                        mobileNumber: phone,
                                        emailAddress: emailAddr
                                      },
                                      signUpAuthToken
                                    );
                                    if (requestotp.status === 'success') {
                                      setReuestOtp(requestotp.data);
                                      setVerifySteps('verifyStepTwo');
                                    }
                                  };

                                  requestotpApi();
                                } else {
                                  setVerifySteps('verifyStepOne');
                                }
                              }}
                            >
                              Resend OTP
                            </Button>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <img src="../static/applicatin.jpg" alt="application" />
                          </Grid>
                        </Grid>
                      ) : (
                        ''
                      )}
                    </>
                  ) : signupSteps === 'personalDetails' ? (
                    <>
                      <Typography variant="h6" className="mb-1">
                        Personal Details
                      </Typography>
                      <Typography variant="body2" className="mb-3">
                        (Please fill in your personal details for the next step)
                      </Typography>
                      <Grid container spacing={3} mb={3}>
                        <Grid item xs={12} sm={6}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              Father Name
                            </Typography>
                            <TextField
                              value={fname}
                              onChange={(e) => {
                                setFname(e.target.value);
                                let getactivepage = '';
                                getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                if (getactivepage != null) {
                                  if (getactivepage.routepage === 'signup-form/Individual') {
                                    getactivepage.stagethree.fname = e.target.value;
                                    localStorage.setItem(
                                      'trackuser',
                                      JSON.stringify(getactivepage)
                                    );
                                  }
                                }
                              }}
                              type="text"
                              variant="outlined"
                              inputProps={{
                                className: 'textInput'
                              }}
                              placeholder="Type Father Name"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              DOB
                            </Typography>
                            <TextField
                              variant="outlined"
                              inputProps={{
                                className: `textInput dissabledMenu${selectDate}`
                              }}
                              placeholder="Select Date of Birth"
                              fullWidth
                              type="date"
                              value={selectDate}
                              onChange={(e) => {
                                handleDob(e);

                                let getactivepage = '';
                                getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                if (getactivepage != null) {
                                  if (getactivepage.routepage === 'signup-form/Individual') {
                                    getactivepage.stagethree.selectDate = e.target.value;
                                    localStorage.setItem(
                                      'trackuser',
                                      JSON.stringify(getactivepage)
                                    );
                                  }
                                }
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              Address
                            </Typography>
                            <TextField
                              value={address}
                              onChange={(e) => {
                                setAddress(e.target.value);
                                let getactivepage = '';
                                getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                if (getactivepage != null) {
                                  if (getactivepage.routepage === 'signup-form/Individual') {
                                    getactivepage.stagethree.address = e.target.value;
                                    localStorage.setItem(
                                      'trackuser',
                                      JSON.stringify(getactivepage)
                                    );
                                  }
                                }
                              }}
                              type="text"
                              variant="outlined"
                              inputProps={{
                                className: 'textInput'
                              }}
                              placeholder="Type Address"
                              fullWidth
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              State
                            </Typography>
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo3"
                              options={stateListResponse}
                              size="small"
                              value={stateValue}
                              onChange={(e, newValue) => {
                                const credential = {
                                  searchLiteral: null,
                                  stateId: newValue.stateId
                                };
                                const CityListApi = async () => {
                                  const CityListResponse = await dispatch(getCityData(credential));
                                  if (CityListResponse.action_status === 'success') {
                                    setCityListResponse(CityListResponse.data);
                                  }
                                };
                                CityListApi();
                                setStateValue(newValue.stateName);
                                setStateID(newValue.stateId);
                                setCityValue('');
                                // setCityListData([]);
                                // setCityListMenu([]);
                                setStateListData(newValue);
                                let getactivepage = '';
                                getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                if (getactivepage != null) {
                                  if (getactivepage.routepage === 'signup-form/Individual') {
                                    getactivepage.stagethree.state = newValue;
                                    localStorage.setItem(
                                      'trackuser',
                                      JSON.stringify(getactivepage)
                                    );
                                  }
                                }
                              }}
                              getOptionLabel={(option) =>
                                option.stateName ? option.stateName : stateValue
                              }
                              renderOption={(props, option) => (
                                <li {...props}>{option.stateName}</li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth placeholder="Select State" />
                              )}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              City
                            </Typography>
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo3"
                              options={cityListResponse}
                              size="small"
                              value={cityValue}
                              onChange={(e, newValue) => {
                                // setCityListData([]);
                                // setCityListMenu([]);
                                setCityListData(newValue);
                                setCityValue(newValue.cityName);
                                setCityID(newValue.cityId);
                                let getactivepage = '';
                                getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                                if (getactivepage != null) {
                                  if (getactivepage.routepage === 'signup-form/Individual') {
                                    getactivepage.stagethree.city = newValue;
                                    localStorage.setItem(
                                      'trackuser',
                                      JSON.stringify(getactivepage)
                                    );
                                  }
                                }
                              }}
                              getOptionLabel={(option) =>
                                option.cityName ? option.cityName : cityValue
                              }
                              renderOption={(props, option) => (
                                <li {...props}>{option.cityName}</li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} fullWidth placeholder="Select City" />
                              )}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                      <Button
                        className="mainBtn"
                        onClick={(e) => {
                          handleSignUpThree(e);
                          let getactivepage = '';
                          getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                          if (getactivepage != null) {
                            if (getactivepage.routepage === 'signup-form/Individual') {
                              getactivepage.stagefour = {};
                              localStorage.setItem('trackuser', JSON.stringify(getactivepage));
                            }
                          }
                        }}
                      >
                        Next
                      </Button>
                    </>
                  ) : signupSteps === 'uploadDocuments' ? (
                    <>
                      <Typography variant="h6" className="mb-1">
                        Upload Documents
                      </Typography>
                      <Typography variant="body2" className="mb-3">
                        (Please Upload your KYC documents for the next step)
                      </Typography>
                      <Grid container alignItems="center" spacing={3} mb={3}>
                        <Grid item xs={12} sm={4}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              Photo
                            </Typography>
                            <input
                              accept="image/png, image/gif, image/jpeg, application/pdf"
                              className="fileInput"
                              id="contained-button-file1"
                              multiple
                              type="file"
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  setPhotoPreview,
                                  setUploadPhoto,
                                  setPhotoPreviewtype1
                                )
                              }
                            />
                            <label
                              htmlFor="contained-button-file1"
                              className={
                                photoPreviewtype1 === 'pdf'
                                  ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                  : `uploadDocBoxLabel uploadDocBoxLabelFull`
                              }
                            >
                              <Box
                                variant="contained"
                                color="primary"
                                component="span"
                                onDragOver={dragOver}
                                onDragEnter={dragEnter}
                                onDragLeave={dragLeave}
                                onDrop={(e) =>
                                  handleFileUpload(
                                    e,
                                    setPhotoPreview,
                                    setUploadPhoto,
                                    setPhotoPreviewtype1
                                  )
                                }
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                              >
                                {photoPreviewtype1 === 'pdf' ? (
                                  <Document
                                    file={photoPreview}
                                    onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                  >
                                    <Pages pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img src={photoPreview} alt="Person" className="previewImage" />
                                )}
                              </Box>
                            </label>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              Aadhar
                            </Typography>
                            <input
                              accept="image/png, image/gif, image/jpeg, application/pdf"
                              className="fileInput"
                              id="contained-button-file2"
                              multiple
                              type="file"
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  setAadharFrontPreview,
                                  setUploadImageFileFront,
                                  setAadharFrontPreviewtype1
                                )
                              }
                            />

                            <label
                              htmlFor={isAadharVerified ? 'contained-button-file2' : undefined}
                              className={
                                aadharFrontPreviewtype1 === 'pdf'
                                  ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                  : `uploadDocBoxLabel uploadDocBoxLabelFull`
                              }
                            >
                              <Box
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                  if (!isAadharVerified) {
                                    setAadharModalOpen(true);
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (!isAadharVerified) {
                                      setAadharModalOpen(true);
                                    }
                                  }
                                }}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                sx={{
                                  cursor: 'pointer',
                                  position: 'relative'
                                }}
                              >
                                {aadharFrontPreviewtype1 === 'pdf' ? (
                                  <Document
                                    file={aadharFrontPreview}
                                    onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                  >
                                    <Pages pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img
                                    src={aadharFrontPreview}
                                    alt="Aadhar"
                                    className="previewImage"
                                  />
                                )}

                                {/* Verify Badge Overlay */}
                                {isAadharVerified && (
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: '-25px',
                                      backgroundColor: 'rgb(50 52 50 / 44%)',
                                      display: 'flex',
                                      alignItems: 'end',
                                      justifyContent: 'center',
                                      color: 'green',
                                      fontWeight: 600,
                                      borderRadius: '4px'
                                    }}
                                  >
                                    <CheckCircleIcon /> Verified
                                  </Box>
                                )}
                              </Box>
                            </label>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              PAN Card
                            </Typography>
                            <input
                              accept="image/png, image/gif, image/jpeg, application/pdf"
                              className="fileInput"
                              id="contained-button-file3"
                              multiple
                              type="file"
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  setPanPreview,
                                  setUploadPanImage,
                                  setPanPreviewtype1
                                )
                              }
                            />
                            <label
                              htmlFor={isPanVerified ? 'contained-button-file3' : undefined}
                              className={
                                panPreviewtype1 === 'pdf'
                                  ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                  : `uploadDocBoxLabel uploadDocBoxLabelFull`
                              }
                            >
                              <Box
                                variant="contained"
                                color="primary"
                                component="span"
                                onDragOver={dragOver}
                                onDragEnter={dragEnter}
                                onDragLeave={dragLeave}
                                onDrop={(e) =>
                                  fileDrop(e, setPanPreview, setUploadPanImage, setPanPreviewtype1)
                                }
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                sx={{ cursor: 'pointer', position: 'relative' }}
                                onClick={() => !isPanVerified && setPanModalOpen(true)}
                              >
                                {panPreviewtype1 === 'pdf' ? (
                                  <Document
                                    file={panPreview}
                                    onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                  >
                                    <Pages pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img src={panPreview} alt="Pan Card" className="previewImage" />
                                )}

                                {/* Verify Badge Overlay */}
                                {isPanVerified && (
                                  <Box
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: '-25px',
                                      backgroundColor: 'rgb(50 52 50 / 44%)',
                                      display: 'flex',
                                      alignItems: 'end',
                                      justifyContent: 'center',
                                      color: 'green',
                                      fontWeight: 600,
                                      borderRadius: '4px'
                                    }}
                                  >
                                    <CheckCircleIcon /> Verified
                                  </Box>
                                )}
                              </Box>
                            </label>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Box className="">
                            <Typography variant="h6" className="formLabel">
                              Cancelled Cheque
                            </Typography>
                            <input
                              accept="image/png, image/gif, image/jpeg, application/pdf"
                              className="fileInput"
                              id="contained-button-file5"
                              multiple
                              type="file"
                              onChange={(e) =>
                                handleFileUpload(
                                  e,
                                  setChequePreview,
                                  setUploadChequeImage,
                                  setChequePreviewtype1
                                )
                              }
                            />
                            <label
                              htmlFor="contained-button-file5"
                              className={
                                chequePreviewtype1 === 'pdf'
                                  ? `pdfBox uploadDocBoxLabel uploadDocBoxLabelFull`
                                  : `uploadDocBoxLabel uploadDocBoxLabelFull`
                              }
                            >
                              <Box
                                variant="contained"
                                color="primary"
                                component="span"
                                onDragOver={dragOver}
                                onDragEnter={dragEnter}
                                onDragLeave={dragLeave}
                                onDrop={(e) =>
                                  fileDrop(
                                    e,
                                    setChequePreview,
                                    setUploadChequeImage,
                                    setChequePreviewtype1
                                  )
                                }
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                              >
                                {/* <img src={chequePreview} alt="Cancel Cheque" className="previewImage" /> */}

                                {chequePreviewtype1 === 'pdf' ? (
                                  <Document
                                    file={chequePreview}
                                    onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
                                  >
                                    <Pages pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img
                                    src={chequePreview}
                                    alt="Cancel Cheque"
                                    className="previewImage"
                                  />
                                )}
                              </Box>
                            </label>
                          </Box>
                        </Grid>
                      </Grid>
                      <Button
                        className="mainBtn"
                        onClick={(e) => {
                          documentValidation(e);
                          let getactivepage = '';
                          getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                          if (getactivepage != null) {
                            if (getactivepage.routepage === 'signup-form/Individual') {
                              getactivepage.stagefifth = {};
                              localStorage.setItem('trackuser', JSON.stringify(getactivepage));
                            }
                          }
                        }}
                      >
                        Next
                      </Button>
                    </>
                  ) : signupSteps === 'results' ? (
                    <>
                      <Typography className="mb-3" variant="h5" textAlign="">
                        Associate Partner/Channel Partner/Authorised Person/Franchisee Service
                        Agreement
                      </Typography>
                      <AgreementText />
                      <Box className="displayFlex alignItemTop" mb={3}>
                        <Checkbox
                          size="small"
                          sx={{ padding: '0 10px 0 0' }}
                          onClick={(e) => setChecked(e.target.checked)}
                          disableRipple
                        />
                        <Typography variant="caption" color="#0d4689">
                          Yes, I understand and agree to the Kalolytic Solutions Terms and
                          Conditions, including User Agreement and Privacy Policy. I declare that
                          the information I have provided is accurate and complete to the best of my
                          knowledge. I hereby authorize Kalolytic Solutions and its affiliates to
                          call, email, send a text through the Short messaging Service (SMS) and/or
                          WhatsApp. The consent herein shall override any registration for DNC/NDNC.
                        </Typography>
                      </Box>
                      <Box textAlign="">
                        <Button
                          className="mainBtn"
                          disabled={checked ? false : true}
                          onClick={async (e) => {
                            const typeId = JSON.parse(localStorage.getItem('typeID'));

                            setOpenAssign(true);

                            let getactivepage = '';
                            getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                            if (getactivepage != null) {
                              if (getactivepage.routepage === 'signup-form/Individual') {
                                getactivepage.stagelast = {};
                                localStorage.setItem('trackuser', JSON.stringify(getactivepage));
                              }
                            }
                          }}
                        >
                          Agree &#38; Submit
                        </Button>
                      </Box>
                      {/* onClose={(e) => setOpenAssign(false)} */}
                      <Dialog open={openAssign} fullWidth>
                        <DialogTitle className="popupTitle">
                          <Typography variant="h6">Congratulations</Typography>
                          <IconButton
                            onClick={(e) => {
                              setOpenAssign(false);
                              let getactivepage = '';
                              getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                              if (getactivepage != null) {
                                if (getactivepage.routepage === 'signup-form/Individual') {
                                  localStorage.removeItem('trackuser');
                                  localStorage.removeItem('reviewobj');
                                }
                              }
                              navigate('/');
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                          <Typography textAlign="center" className="mb-2">
                            <BsPatchCheck fontSize={50} color="#a6ce39" />
                          </Typography>
                          <Typography variant="body1" textAlign="center" className="mb-2">
                            Your digital application have been successfully processed and your
                            Partner account has been opened successfully.
                          </Typography>
                          <Typography variant="body1" textAlign="center">
                            We have mailed your Partner account User Id and Password on your
                            registered email id
                          </Typography>
                          <Typography variant="body1" textAlign="center">
                            <Link to="/">{emailAddr}</Link>
                          </Typography>
                          {/* <Typography variant="body1" className="mb-3" textAlign="center">
                            You can Download our App by clicking below and log in with your details
                            to proceed further.
                          </Typography> */}
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={(e) => {
                              setOpenAssign(false);
                              let getactivepage = '';
                              getactivepage = JSON.parse(localStorage.getItem('trackuser'));
                              if (getactivepage != null) {
                                if (getactivepage.routepage === 'signup-form/Individual') {
                                  localStorage.removeItem('trackuser');
                                  localStorage.removeItem('reviewobj');
                                }
                              }
                              navigate('/');
                            }}
                            variant="contained"
                            className="mainBtn"
                          >
                            close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </>
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Dialog for validation verify Identity */}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className="popupTitle">
            <Typography variant="h6">&nbsp;</Typography>
            <IconButton onClick={(e) => setOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box py={1} px={4} textAlign="center">
                <Typography variant="subtitle2">{validationMsg}</Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" className="mainBtn" onClick={handleClose}>
              Retry
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dialog for validation verify Identity end */}

        <Dialog open={emailOtpOpen} onClose={() => setEmailOtpOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Email OTP</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              value={emailOtp}
              onChange={(e) => setEmailOtp(e.target.value)}
              placeholder="Enter OTP"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEmailOtpOpen(false)}>Cancel</Button>
            <Button onClick={handleEmailVerifyOtp} disabled={otpLoading}>
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={mobileOtpOpen}
          onClose={() => setMobileOtpOpen(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Mobile OTP</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              value={mobileOtp}
              onChange={(e) => setMobileOtp(e.target.value)}
              placeholder="Enter OTP"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setMobileOtpOpen(false)}>Cancel</Button>
            <Button onClick={handleMobileVerifyOtp} disabled={otpLoading}>
              Verify
            </Button>
          </DialogActions>
        </Dialog>

        {/* AADHAR VERIFICATION DIALOG */}
        <Dialog
          open={aadharModalOpen}
          onClose={() => {
            setAadharModalOpen(false);
            setAadharNumber('');
            setAadharOtpValue('');
            setOtpGenerated(false);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Verify Aadhar</DialogTitle>

          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Upload Aadhar Document
                </Typography>

                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  className="fileInput"
                  id="aadhar-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setUploadAadharForVerification(e.target.files[0]);
                      const reader = new FileReader();
                      reader.onload = (event) =>
                        setAadharPreviewForVerification(event.target.result);
                      reader.readAsDataURL(e.target.files[0]);
                    }
                  }}
                />

                <label
                  htmlFor="aadhar-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '2px dashed #1976d2',
                      borderRadius: '8px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f5f5f5',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        borderColor: '#1565c0'
                      }
                    }}
                  >
                    {uploadAadharForVerification ? (
                      <img
                        src={aadharPreviewForVerification}
                        alt="Aadhar Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                          📁 Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#999' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: Aadhar Number Input */}
              {uploadAadharForVerification && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                    Enter Aadhar Number
                  </Typography>
                  <TextField
                    fullWidth
                    label="Aadhar Number"
                    value={aadharNumber}
                    onChange={(e) =>
                      setAadharNumber(e.target.value.replace(/\D/g, '').slice(0, 12))
                    }
                    placeholder="Enter 12-digit Aadhar number"
                    variant="outlined"
                    inputProps={{
                      maxLength: 12,
                      pattern: '[0-9]{12}'
                    }}
                    helperText={`${aadharNumber.length}/12 digits`}
                  />
                </Box>
              )}

              {/* Step 3: OTP Input */}
              {otpGenerated && (
                <Box>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                    Enter OTP
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#666', mb: 2 }}>
                    OTP has been sent to your registered mobile number
                  </Typography>
                  <TextField
                    fullWidth
                    label="OTP"
                    value={aadharOtpValue}
                    onChange={(e) =>
                      setAadharOtpValue(e.target.value.replace(/\D/g, '').slice(0, 6))
                    }
                    placeholder="Enter 6-digit OTP"
                    variant="outlined"
                    inputProps={{
                      maxLength: 6,
                      pattern: '[0-9]{6}'
                    }}
                    helperText={`${aadharOtpValue.length}/6 digits`}
                  />
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setAadharModalOpen(false);
                setAadharNumber('');
                setAadharOtpValue('');
                setOtpGenerated(false);
              }}
            >
              Close
            </Button>

            {uploadAadharForVerification && !otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharSend()}
                disabled={aadharOtpLoading || !aadharNumber || aadharNumber.length < 12}
              >
                {aadharOtpLoading ? 'Sending...' : 'Send OTP'}
              </Button>
            )}

            {otpGenerated && (
              <Button
                variant="contained"
                onClick={() => handleAadharVerifyOtp()}
                disabled={aadharOtpLoading || !aadharOtpValue || aadharOtpValue.length < 6}
              >
                {aadharOtpLoading ? 'Verifying...' : 'Verify'}
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* PAN VERIFICATION DIALOG */}
        <Dialog
          open={panModalOpen}
          onClose={() => {
            setPanModalOpen(false);
            setPanNumber('');
            setPanName('');
            setPanDob('');
            setUploadPanForVerification(null);
            setPanPreviewForVerification('');
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: 600 }}>Verify PAN</DialogTitle>

          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Step 1: Image Upload & Display */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Upload PAN Document
                </Typography>

                <input
                  accept="image/png, image/gif, image/jpeg, application/pdf"
                  className="fileInput"
                  id="pan-modal-file-input"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files[0]) {
                      setUploadPanForVerification(e.target.files[0]);
                      const reader = new FileReader();
                      reader.onload = (event) => setPanPreviewForVerification(event.target.result);
                      reader.readAsDataURL(e.target.files[0]);
                    }
                  }}
                />

                <label
                  htmlFor="pan-modal-file-input"
                  style={{ cursor: 'pointer', display: 'block' }}
                >
                  <Box
                    sx={{
                      border: '2px dashed #1976d2',
                      borderRadius: '8px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f5f5f5',
                      minHeight: '200px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: '#e3f2fd',
                        borderColor: '#1565c0'
                      }
                    }}
                  >
                    {uploadPanForVerification ? (
                      <img
                        src={panPreviewForVerification}
                        alt="PAN Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '180px',
                          objectFit: 'contain'
                        }}
                      />
                    ) : (
                      <Box sx={{ textAlign: 'center' }}>
                        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
                          📁 Click to browse or drag & drop
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#999' }}>
                          PNG, JPG, GIF, or PDF
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </label>
              </Box>

              {/* Step 2: PAN Number Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  PAN Number
                </Typography>
                <TextField
                  fullWidth
                  label="PAN Number"
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value.toUpperCase().slice(0, 10))}
                  placeholder="Enter 10-character PAN (e.g., HGOPS2791P)"
                  variant="outlined"
                  inputProps={{
                    maxLength: 10
                  }}
                  helperText={`${panNumber.length}/10 characters`}
                />
              </Box>

              {/* Step 3: Full Name Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Full Name
                </Typography>
                <TextField
                  fullWidth
                  label="Full Name"
                  value={panName}
                  onChange={(e) => setPanName(e.target.value)}
                  placeholder="Enter full name (as per PAN)"
                  variant="outlined"
                />
              </Box>

              {/* Step 4: Date of Birth Input */}
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
                  Date of Birth
                </Typography>
                <TextField
                  fullWidth
                  type="date"
                  label="DOB"
                  value={panDob}
                  onChange={(e) => setPanDob(e.target.value)}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setPanModalOpen(false);
                setPanNumber('');
                setPanName('');
                setPanDob('');
                setUploadPanForVerification(null);
                setPanPreviewForVerification('');
              }}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => handlePanVerify()}
              disabled={
                panVerificationLoading ||
                !panNumber ||
                panNumber.length < 10 ||
                !panName ||
                !panDob ||
                !uploadPanForVerification
              }
            >
              {panVerificationLoading ? 'Verifying...' : 'Verify'}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}

export default SignUpIndividual;
